import { render, staticRenderFns } from "./RadioBoxes.vue?vue&type=template&id=8220e458"
import script from "./RadioBoxes.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioBoxes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports